export default __webpack_public_path__ + "static/media/followIcon.409b4e99.svg";